{
  "list": {
    "title": "الأنظمة المرتبطة",
    "add": "إضافة نظام",
    "columns": {
      "code": "الرمز",
      "name": "الاسم",
      "status": "الحالة",
      "lastUsedAt": "آخر استخدام",
      "createdAt": "تاريخ الإنشاء"
    },
    "neverUsed": "لم يستخدم بعد",
    "rowActions": {
      "trigger": "إجراءات {{name}}",
      "rotateSecret": "تجديد المفتاح السري"
    }
  },
  "drawer": {
    "createTitle": "إضافة نظام",
    "editTitle": "تعديل النظام",
    "createDescription": "تسجيل منصة يسمح لها بإرسال الرسائل عبر هذه الخدمة.",
    "editDescription": "تحديث اسم هذا النظام.",
    "fields": {
      "code": "الرمز",
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية"
    },
    "created": "تم إنشاء النظام بنجاح",
    "updated": "تم تحديث النظام بنجاح"
  },
  "secret": {
    "createTitle": "المفتاح السري الجديد",
    "rotateTitle": "المفتاح السري الجديد",
    "description": "انسخ هذا المفتاح السري الآن، فلن يظهر مرة أخرى لأسباب أمنية.",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "close": "إغلاق"
  },
  "rotateConfirmTitle": "تجديد المفتاح السري لهذا النظام؟",
  "rotateConfirmDescription": "سيتوقف \"{{name}}\" عن العمل بمفتاحه السري الحالي فورا.",
  "statusConfirmTitle": "تغيير حالة هذا النظام؟",
  "statusConfirmDescription": "سيصبح \"{{name}}\" {{status}}.",
  "statusChanged": "تم تغيير حالة النظام بنجاح",
  "secretRotated": "تم تجديد المفتاح السري بنجاح"
}
